import { BUTTON_LINK_OFFERS, BUTTON_LINK_OFFERS_WEBVIEW } from 'shared/constants/buttonLink';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const useRedirect = () => {
  const { config, webview } = useApplicationContext();

  const isWebView = !!config.get<boolean>('web.isWebView');

  const redirect = () => {
    const fixUrl = isWebView ? BUTTON_LINK_OFFERS_WEBVIEW : BUTTON_LINK_OFFERS;
    if (isWebView) {
      webview.sendAction({
        action: 'open-deeplink',
        payload: {
          url: fixUrl,
        },
      });
    }

    location.replace(fixUrl);
  };

  return { redirect };
};
